export default __webpack_public_path__ + "static/media/instructionLogo.1a4a74b7.png";